import { render } from "./ProductOverviewBrands.vue?vue&type=template&id=477a1b3e&scoped=true"
import script from "./ProductOverviewBrands.vue?vue&type=script&lang=js"
export * from "./ProductOverviewBrands.vue?vue&type=script&lang=js"

import "./ProductOverviewBrands.vue?vue&type=style&index=0&id=477a1b3e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-477a1b3e"]])

export default __exports__